<template>
    <span>{{ description }}</span>
</template>

<script>

export default {

    props: [ 'stamp' ],

    computed: {

        description() {
            switch (this.stamp.type) {
                case 'AWARD':
                    return 'Redeemed ' + this.stamp.award_name;
                case 'DEPOSIT':
                    return 'Added by ' + this.stamp.awarded_by.first_name;
                case 'WITHDRAWAL':
                    return 'Subtracted by ' + this.stamp.awarded_by.first_name;
            }
        },
    }

}

</script>



// WEBPACK FOOTER //
// resources/js/components/passport/LedgerItemDescription.vue